import { createContext, useContext } from 'react';
import { SearchDialogItem } from 'src/components/SearchDialog/search-dialog';

export interface QuickAction extends SearchDialogItem {
  order?: number;
  keywords?: string[];
  handler: () => void;
}

export type QuickActionKey = string | ((...args: unknown[]) => unknown);

export const QuickActionsContext = createContext<{
  addActions: (actions: QuickAction | QuickAction[]) => void;
  removeActions: (actions: QuickAction | QuickAction[]) => void;
  updateAndRestoreAction: (
    actionKey: QuickActionKey,
    data: Partial<QuickAction>,
    options?: {
      skip?: boolean;
    },
  ) => () => void;
  getActionById: (actionKey: QuickActionKey) => QuickAction | null;
}>({
  addActions: () => undefined,
  removeActions: () => undefined,
  updateAndRestoreAction: () => () => undefined,
  getActionById: () => null,
});

export const useQuickActionsContext = () => useContext(QuickActionsContext);
